import { render, staticRenderFns } from "./MoreInfoDialog.vue?vue&type=template&id=05840a3e&scoped=true"
import script from "./MoreInfoDialog.vue?vue&type=script&lang=js"
export * from "./MoreInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./MoreInfoDialog.vue?vue&type=style&index=0&id=05840a3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05840a3e",
  null
  
)

export default component.exports